<template>
    <div>
        <navbar1></navbar1>
        <div class="__mobilebg">
            <div class="container">
                <p class="__bepro">Mobile Development</p>
            </div>
        </div>
        <div class="container">
            <div class="__mtop">
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-7">
                        <p class="__courdes">Description</p>
                        <p class="__courdes1">Mobile Development encompasses the creation of apps for use on devices such as tablets, smartphones, automobiles and watches. Mobile apps are designed and built for different operating systems. The Android operating system and Apple’s iOS are the most popular.</p>
                        <p class="__courdes">What you'll learn</p>
                        <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; ReactNative</p>
                        <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Git and Commandline</p>
                        <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; And finally build a complete website</p>
                        <p class="__courdes">Requirement</p>
                        <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; A laptop</p>
                        <p class="__courdes">Academy Location</p>
                        <p class="__courdes1">Lagos, Ibadan, Abeokuta, Port-Hacourt, Abuja</p>
                        <p class="__courdes">Learning Type</p>
                        <p class="__courdes1">ONSITE (Cohort 1 Academy Classes would ONLY Take place at our provided Facilities in Lagos)</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-5">
                        <div class="__coursecard">
                            <p class="__courst">Timeline</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst1">Application Opens</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst2">May 24th 2020</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst1">Application Closes</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst3">May 24th 2020</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst1">Academy Starts</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst2">April 15th 2020</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst1">Academy Ends</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst3">July 19th 2020</p>
                                </div>
                            </div>
                        </div>
                        <div class="__coursecard">
                            <p class="__courst">Class</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst1">Starts</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst2">April 15th 2020</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst1">Ends</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst3">July 19th 2020</p>
                                </div>
                            </div>
                        </div>
                        <div class="__coursecard">
                            <p class="__courst">Days/Time</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                    <p class="__courst1">Mon-Sat</p>
                                </div>
                                <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                    <p class="__courst2">09:00am-12:00pm</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                    <p class="__courst1">Sun</p>
                                </div>
                                <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                    <p class="__courst2">12:00pm-04:00pm</p>
                                </div>
                            </div>
                        </div>
                        <div class="__coursecard">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst1">Price</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <p class="__courst4">200,000</p>
                                </div>
                            </div>
                        </div>
                        <a href="https://paystack.com/pay/mobile-dev-track" class="btn btn-block __applnowbtn">Apply Now!</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from '../components/navbar1';
    export default {
        components:{navbar1,},
    }
</script>

<style scoped>
    @import '../assets/css/devstack';
</style>


// WEBPACK FOOTER //
// src/components/mobiledevelopment.vue